import React from 'react'
import { HeightTruncate } from '@mobi/component-library/Misc/HeightTruncate'

export const HeightTruncateWrapper: React.FC<{
  children: React.ReactNode
  isEnabled: boolean
  onChangeCallback: (expanded: boolean) => void
}> = ({ children, isEnabled, onChangeCallback }) => {
  if (!isEnabled) return children

  return (
    <HeightTruncate maxHeightRem={30} onChangeCallback={onChangeCallback}>
      {children}
    </HeightTruncate>
  )
}
